<template>
  <div class="card" v-bind:class="cardColor">
    <h2 class="card-h2" v-bind:class="[{'s-icon': cardIcon}]">
      <span><i v-if="cardIcon" class="material-icons card-icon">{{cardIcon}}</i> {{title}}</span>
    </h2>
    <div class="card-content">
      <BarChart :bar-color="barColor"
                :chart-data="chartData" 
                :chart-height="chartHeight"
                :chart-type="chartType"
                :label-prefix="labelPrefix"
                :legend-color="legendColor"
                :legend-link="legendLink"
                :show-legend="showLegend"
                :stacked="stacked"
                :x-max-axes-rotation="xMaxAxesRotation"
                :x-min-axes-rotation="xMinAxesRotation"></BarChart>

      <table v-bind:class="tableColor">
        <thead>
          <tr>
            <th>Severity</th>
            <th>Count</th>
            <th>% of Cost</th>
            <th>Cost</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in tableData.amounts">
            <td>{{ data.title }}</td>
            <td>{{ Number(data.count).toLocaleString('en-US') }}</td>
            <td>{{ Number(data.percent).toLocaleString('en-US', {maximumFractionDigits: 2}) }}%</td>
            <td>${{ Number(data.amount).toLocaleString('en-US') }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="highlight" colspan="3">Total</td>
            <td class="highlight">${{ Number(tableData.total).toLocaleString('en-US') }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/barCharts/BarChart'

export default {
  name: 'damageCosts',

  props: {
    'cardColor': {
      type: String,
      required: false,
      default: 'green'
    },
    'cardIcon': {
      type: String,
      required: false,
      default: 'attach_money'
    },
    'getter': {
      type: String,
      required: true
    },
    'tableColor': {
      type: String,
      required: false,
      default: 'green'
    },
    'title': {
      type: String,
      required: false
    },

    // == Bar Chart options/props in BarChart.vue

    'barColor': {
      type: String,
      required: false
    },
    'chartHeight': {
      type: Number,
      required: false,
      default: 180
    },
    'chartType': {
      type: String,
      required: false,
      default: 'bar'
    },
    'labelPrefix': {
      type: String,
      required: false,
      default: ' $'
    },
    'legendColor': {
      type: String,
      required: false
    },
    'legendLink': {
      type: String,
      required: false
    },
    'showLegend': {
      type: Boolean,
      required: false,
      default: false
    },
    'stacked': {
      type: Boolean,
      required: false,
      default: false
    },
    'xMaxAxesRotation': {
      type: Number,
      required: false,
      default: 90
    },
    'xMinAxesRotation': {
      type: Number,
      required: false,
      default: 0
    }
  },

  components: {
    'BarChart': BarChart
  },

  computed: {
    chartData () {
      return (this.$store.getters[this.getter].amounts) ? this.$store.getters[this.getter].amounts : []
    },

    tableData () {
      return this.$store.getters[this.getter]
    }
  }
}
</script>



// WEBPACK FOOTER //
// DamageCosts.vue?8836e8fe